import type { Language } from './i18n';

export function isLanguage(value: unknown): value is Language {
  return value === 'en' || value === 'zh';
}

function canonicalLocale(value: unknown): string | null {
  if (typeof value !== 'string' || !value.trim()) return null;
  try {
    return Intl.getCanonicalLocales(value.trim().replace(/_/g, '-'))[0] ?? null;
  } catch {
    return null;
  }
}

export function browserLanguage(primary: unknown, fallback: unknown): Language {
  const locale = canonicalLocale(primary) ?? canonicalLocale(fallback);
  return locale?.split('-')[0].toLowerCase() === 'zh' ? 'zh' : 'en';
}

export function initialLanguage(
  urlValue: string | null,
  savedValue: unknown,
  savedIsManual: boolean,
  primaryBrowserLocale: unknown,
  fallbackBrowserLocale: unknown,
  pageLanguage: Language | null = null,
): Language {
  if (isLanguage(urlValue)) return urlValue;
  if (pageLanguage) return pageLanguage;
  if (savedIsManual && isLanguage(savedValue)) return savedValue;
  return browserLanguage(primaryBrowserLocale, fallbackBrowserLocale);
}
